import _ from 'lodash';
import {GetterTree} from 'vuex';
import {BioServicesConstant, EmployeeStateConstant} from '../constants';
import BioAdmin from 'types/ba/bioAdmin';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationGetters: GetterTree<LtFramework.IAlertNotificationState, LtFramework.IRootState> = {
	getState: (state: LtFramework.IAlertNotificationState) => {
		return state.alertNotifications;
	},
};

export const EmployeeProfileGetters: GetterTree<LtFramework.IEmployeeProfileState, LtFramework.IRootState> = {
	getState: (state: LtFramework.IEmployeeProfileState) => {
		return state.employeeProfile;
	},
	getIsValid: (state: LtFramework.IEmployeeProfileState) => {
		return state && state.employeeProfile && state.employeeProfile.partyId > 0 && state.employeeProfile.employeeDetails && state.employeeProfile.employeeDetails.employeeId > 0 && state.employeeProfile.employeeState !== EmployeeStateConstant.unauthenticated;
	},
	getEmployeeId: (state: LtFramework.IEmployeeProfileState) => {
		if (state.employeeProfile.employeeDetails != null && typeof state.employeeProfile.employeeDetails !== 'undefined') {
			return state.employeeProfile.employeeDetails.employeeId;
		} else {
			return null;
		}
	},
};

export const BioProfileGetters: GetterTree<BioAdmin.IBioProfileState, LtFramework.IRootState> = {
	getState: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile;
	},
	getIsValid: (state: BioAdmin.IBioProfileState) => {
		return state && state.bioProfile && state.bioProfile.email;
	},
	getClubs: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.clubs;
	},
	getAvatarId: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.avatarId;
	},
	getPublishStatus: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.publishStatus;
	},
	getPublicBioUrl: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.publicBioUrl;
	},
	getBioProfilePaths: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.profiles;
	},
	getPublishedProfile: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.publishedProfile;
	},
	getTagGroup: (state: BioAdmin.IBioProfileState) => (name: string): BioAdmin.ITagGroup => {
		let tagGroup: BioAdmin.ITagGroup;
		const index = _.findIndex(state.bioProfile.tagGroups, (group: BioAdmin.ITagGroup) => {
			return group.name === name;
		});
		tagGroup = state.bioProfile.tagGroups[index];
		return tagGroup;
	},
	getServices: (state: BioAdmin.IBioProfileState) =>  {
		return state.bioProfile.services;
	},
	getSpecialties: (state: BioAdmin.IBioProfileState) => {
		if (state.bioProfile.tagGroups && state.bioProfile.tagGroups.length > 0) {
			const index = _.findIndex(state.bioProfile.tagGroups, (group: BioAdmin.ITagGroup) => {
				return group.name === BioServicesConstant.specialtiesName;
			});
			if (state.bioProfile.tagGroups[index] && state.bioProfile.tagGroups[index].tags) {
				return state.bioProfile.tagGroups[index].tags;
			}
		}
	},
	getLanguages: (state: BioAdmin.IBioProfileState) => {
		if (state.bioProfile.tagGroups && state.bioProfile.tagGroups.length > 0) {
			const index = _.findIndex(state.bioProfile.tagGroups, (group: BioAdmin.ITagGroup) => {
				return group.name === BioServicesConstant.languagesName;
			});
			if (state.bioProfile.tagGroups[index] && state.bioProfile.tagGroups[index].tags) {
				return state.bioProfile.tagGroups[index].tags;
			}
		}
	},
	getSocialLinks: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.socialLinks;
	},
	getSocialUrl: (state: BioAdmin.IBioProfileState) => (type: string) => {
		const socialObj: any = _.find(state.bioProfile.socialLinks, (so: BioAdmin.ISocialLink) => {
			return so.type === type;
		});
		if (typeof socialObj !== 'undefined' && socialObj != null) {
			return socialObj.link;
		} else {
			return '';
		}
	},
	getCertifications: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.certifications;
	},
	getQuote: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.quote;
	},
	getQuoteCitation: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.quoteCitation;
	},
	getAboutMe: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.aboutMe;
	},
	getSchedule: (state: BioAdmin.IBioProfileState) => (dayIndex: number, timeIndex: number, clubId: any) => {
		const profileClub: any = _.find(state.bioProfile.clubs, (club: any) => {
			return club.clubId === clubId;
		});
		if (profileClub.schedule) {
			return profileClub.schedule[dayIndex].items[timeIndex].active;
		} else {
			return false;
		}
	},
	getVisibility: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.visible;
	},
	getPromoted: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.promoted;
	},
	getDPTFlag: (state: BioAdmin.IBioProfileState) => {
		return state.bioProfile.dptFlag;
	},
	getJobTitles: (state: BioAdmin.IBioProfileState) => {
		return _.uniqBy(state.bioProfile.jobTitleList, (jtl: BioAdmin.IJobTitle) => jtl.marketingTitle);
	},
	getBiosImages: (state: BioAdmin.IBioProfileState) => {
		return  _.filter(Object.entries(state.bioProfile.biosImages || {}),
				entry => entry[0].includes('dpt-') && entry[1])
			.map((item: any)  => item[1].aem || item[1].dynamicMedia);
	},
};

export const UrlGetters: GetterTree<LtFramework.IUrlState, LtFramework.IRootState> = {
	getGlobalPageDriverUrl: (state: LtFramework.IUrlState) => (section: string, page: string) => {
		if (!section) {
			throw new Error('Section is not defined');
		}

		if (!page) {
			throw new Error('Page is not defined');
		}

		if (!state.url.globalPageDrivers[section]) {
			throw new Error('Section ' + section + ' doesn\'t exist in global page drivers');
		}

		if (!state.url.globalPageDrivers[section][page]) {
			throw new Error('Page ' + page + ' doesn\'t exist in global page drivers');
		}

		const url: string = state.url.globalPageDrivers[section][page];

		return url;
	},
	getState: (state: LtFramework.IUrlState) => {
		return state.url;
	},
	getUrlParameter: (state: LtFramework.IUrlState) => (parameter: string) => {
		const url: string = location.href;
		parameter = parameter.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
		const regexS = '[\\?&]' + parameter + '=([^&#]*)';
		const regex = new RegExp( regexS );
		const results = regex.exec( url );
		return results == null ? null : results[1];
	},
};
